import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

const CisContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: ${({ theme }) => `${theme.grid.gutter / 2}px`};
  padding-right: ${({ theme }) => `${theme.grid.gutter / 2}px`};
  width: 98%;
  max-width: 100% !important;

  ${({
    theme: {
      grid: { containerFullScreenMaxWidths },
    },
  }) =>
    Object.keys(containerFullScreenMaxWidths).map((key) => {
      return css`
        ${breakpoint(key)`
          max-width: ${containerFullScreenMaxWidths[key]};
        `}
      `;
    })}
`;

export default CisContainer;
